import TokenResource from "./TokenResource";

export default class DocumentsResource extends TokenResource {
	docID = 0;
	setName = "";

	pk() {
		return this.docID?.toString() ?? "";
	}

	static urlRoot = "/api/documents/application";
}
